// data/contact.ts

import {
  FaInstagram,
  FaLinkedin,
  FaEnvelope,
} from "react-icons/fa";
import type { IconType } from "react-icons";

export type ContactReason = "general" | "sales" | "support";

export interface ContactChannel {
  label: string;
  email: string;
  description: string;
}

export interface HourEntry {
  day: string;
  time: string;
}

export interface SocialLink {
  label: string;
  href: string;
  Icon: IconType;
}

export interface FAQItem {
  question: string;
  answer: string;
}

export const CONTACT_CHANNELS: ContactChannel[] = [
  {
    label: "General Enquiries",
    email: "priority@thequalitycollection.com",
    description:
      "For product information, manufacturing capabilities, company details, and general business enquiries.",
  },
  {
    label: "Sales & Export",
    email: "sales@thequalitycollection.com",
    description:
      "Request quotations, discuss custom product development, OEM/ODM projects, bulk manufacturing, and international exports.",
  },
  {
    label: "Customer Support",
    email: "care@thequalitycollection.com",
    description:
      "Need assistance with an existing order, production updates, shipping, or after-sales support? Our team is here to help.",
  },
];

export const STUDIO_HOURS: HourEntry[] = [
  { day: "Monday – Saturday", time: "9:00 AM – 6:30 PM" },
  { day: "Sunday", time: "Closed" },
];

export const SOCIAL_LINKS: SocialLink[] = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/thequalityexports/?hl=en",
    Icon: FaInstagram,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/feed/",
    Icon: FaLinkedin,
  },
  {
    label: "Email",
    href: "mailto:priority@thequalitycollection.com",
    Icon: FaEnvelope,
  },
];

export const CONTACT_FAQS: FAQItem[] = [
  {
    question: "Can I order fully customized products?",
    answer:
      "Yes. We specialize in custom manufacturing. Share your sketch, 3D design, reference image, or concept, and our team will develop it into a premium product.",
  },
  {
    question: "Do you export products internationally?",
    answer:
      "Absolutely. We serve clients worldwide and manage manufacturing, quality inspections, packaging, and export documentation for smooth global deliveries.",
  },
  {
    question: "What materials do you work with?",
    answer:
      "We manufacture products using Brass, Copper, Stainless Steel, Iron, Aluminum, Wood, Marble, Glass, Resin, Leather, and various mixed-material combinations.",
  },
  {
    question: "Can I request product samples before production?",
    answer:
      "Yes. Prototype and sample development is available to ensure every design, finish, and specification meets your expectations before mass production begins.",
  },
  {
    question: "How can I request a quotation?",
    answer:
      "Simply email our Sales & Export team with your product details, drawings, dimensions, quantities, or reference images. We'll prepare a customized quotation and manufacturing plan.",
  },
];

export const STUDIO_COORDS = {
  lat: 28.8467,
  lng: 78.7767,
  address:
    "The Quality Collection Private Limited, Near Behind Petrol Pump, Tajpur Mafi, Dalpatpur Road",
  city: "Moradabad, Uttar Pradesh 244001, India",
};

export const CONTACT_REASONS: {
  value: ContactReason;
  label: string;
}[] = [
    {
      value: "general",
      label: "General Enquiry",
    },
    {
      value: "sales",
      label: "Sales & Export",
    },
    {
      value: "support",
      label: "Customer Support",
    },
  ];